window.app = window.app || {};

jQuery(function($) {

    function initializeMicroform(captureContextData, formStyles) {

        window.app.microform = undefined;

        window.app.microformFields = {
            number: {
                type: 'number',
                instance: null,
                loaded: false,
                valid: false,
                empty: true,
                maskOnBlur: false,
            },
            securityCode: {
                type: 'securityCode',
                instance: null,
                loaded: false,
                valid: false,
                empty: true,
                maskOnBlur: false,
            },
        };
    }

    window.app.initializeMicroform = initializeMicroform;

	function loadFlexMicroformScript(captureContextData, formStyles) {

        var captureContext = captureContextData.captureContext;

        if (!isScriptLoaded(captureContextData.clientLibrary)) {

            var $script = document.createElement('script')

            $script.type = 'text/javascript';
            $script.async = true;
            $script.src = captureContextData.clientLibrary;

            if (captureContextData.clientLibraryIntegrity) {

                $script.integrity = captureContextData.clientLibraryIntegrity;
                $script.crossOrigin = "anonymous";
            }

            $script.onload = function() {

                console.log("Script loaded successfully.");

                // Invoke the Flex SDK once the scripts are loaded asynchronously
                flexSetup(captureContext, formStyles);
            }
            document.head.appendChild($script);
        }
        else {
            flexSetup(captureContext, formStyles);
        }
	}

	window.app.loadFlexMicroformScript = loadFlexMicroformScript;

    function isScriptLoaded(targetUrl) {

        var isLoaded = false;

        // Use jQuery to select all script tags
        $('script').each(function() {
            var src = $(this).attr('src');

            // We check if the attribute exists and matches our target
            if (src && src.indexOf(targetUrl) !== -1) {
                isLoaded = true;
                return false; // This breaks the jQuery .each() loop early
            }
        });

        return isLoaded;
    }

	function flexSetup(captureContext, formStyles) {

		// setup
		var flex = new Flex(captureContext);
		var microform = flex.microform({styles: formStyles});

		$.each(window.app.microformFields, function(key,valueObj) {

			valueObj['instance'] = microform.createField(valueObj['type'], {placeholder: valueObj['placeholder']});

			valueObj['instance'].on('change', function(data) {

				valueObj['valid'] = data.valid;
				valueObj['empty'] = data.empty;

                var $fieldContainer = $('#' + valueObj['type'] + '-container');

                if (!valueObj.empty) {
                    $fieldContainer.closest('.form-group').find('label').addClass('active');
                }
			});

			valueObj['instance'].on('blur', function() {

				var $fieldContainer = $('#' + valueObj['type'] + '-container');

                if (valueObj.empty) {
                    $fieldContainer.closest('.form-group').find('label').removeClass('active');
                }

				if (valueObj['maskOnBlur'] && !valueObj['empty']) {
					$fieldContainer.addClass('flex-microform-blurred');
				}
			});

			valueObj['instance'].on('focus', function() {

				var $fieldContainer = $('#' + valueObj['type'] + '-container');

				$fieldContainer.closest('.form-group').find('label').addClass('active');

				if (valueObj['maskOnBlur']) {
					$fieldContainer.removeClass('flex-microform-blurred');
				}
			});

			valueObj['instance'].on('load', function() {

				valueObj['loaded'] = true;

				var allFieldsLoaded = true;
				$.each(window.app.microformFields, function(key,valueObj) {

					allFieldsLoaded = allFieldsLoaded && valueObj['loaded'];
				});

				if (allFieldsLoaded) {
					console.log('Fields are loaded. It is now safe to create a token.');
					window.app.microform = microform;
				}
			});

			valueObj['instance'].load('#' + valueObj['type'] + '-container');
		});

	}

    window.app.flexSetup = flexSetup;

});
